<template>
  <q-banner
    class="dialog-banner full-width"
    :class="{'bg-grey-2': type === 'TEXT'}"
    :style="{background: backgroundStyle}"
  >
    <div
      v-if="icon"
      class="row full-width justify-center q-my-sm"
    >
      <q-icon
        :name="icon"
        size="3rem"
        :color="iconColor"
        aria-hidden="true"
      />
    </div>
    <slot />
  </q-banner>
</template>
<script>
import { computed, toRefs } from 'vue'
import { colors } from 'quasar'

const { getPaletteColor } = colors

export default {
  props: {
    type: {
      type: String,
      default: 'TEXT'
    }
  },
  setup (props) {
    const propRefs = toRefs(props)

    const icon = computed(() => {
      switch (propRefs.type.value) {
        case 'SUCCESS':
          return 'sym_o_check'
        case 'ERROR':
        case 'WARNING':
          return 'sym_o_warning'
        case 'TEXT':
        default:
          return false
      }
    })

    const iconColor = computed(() => {
      switch (propRefs.type.value) {
        case 'SUCCESS':
          return 'positive'
        case 'ERROR':
          return 'negative'
        case 'WARNING':
          return 'warning'
        case 'TEXT':
        default:
          return undefined
      }
    })

    const backgroundStyle = computed(() => {
      switch (propRefs.type.value) {
        case 'SUCCESS':
          return 'rgb(from var(--q-positive) r g b / 10%)'
        case 'ERROR':
          return 'rgb(from var(--q-negative) r g b / 10%)'
        case 'WARNING':
          return `rgb(from ${getPaletteColor('amber-6')} r g b / 10%)`
      }
      return 'unset'
    })

    return {
      icon,
      iconColor,
      backgroundStyle
    }
  }
}
</script>
<style>
.dialog-banner {
  ul {
      padding-inline-start: 1rem;
  }
}
</style>
